<template>
  <b-sidebar id="sidebar-menu" right shadow backdrop backdrop-variant="light">
    <slot />
  </b-sidebar>
</template>

<script>
export default {
  name: "MenuSidebar",
};
</script>

<style scoped lang="scss">
::v-deep .b-sidebar-header {
  background: $color-white;
  text-align: right;
  display: block;
  padding: 0;

  .close {
    color: $color-blue !important;
    font-size: 2rem;
    opacity: 1;
    padding: ($spacer / 1.75) ($spacer / 1.75) 0 0;

    svg {
      width: 32px;
      height: 32px;
    }
  }
}
::v-deep #sidebar-menu {
  width: 100%;
}
::v-deep .b-sidebar-body {
  background: $color-white;
  .navbar-nav {
    padding: 0 ($spacer * 1.5);

    .nav-item {
      border-bottom: 1px solid $color-dark-600;
      flex-direction: column;
    }

    .nav-link {
      font-weight: bold;
      width: 100%;
      padding: $spacer 0;
      color: $color-dark;

      &:after {
        right: 10px;
        position: absolute;
        top: 25px;
      }

      &:hover {
        color: $color-blue;
      }
    }

    .dropdown-menu {
      transform: none !important;
      position: relative !important;
      width: 100%;
      border: none;
    }
    li {
      &:not(.active) {
        .dropdown-item {
          color: $color-dark;
          margin: ($spacer * 0.5) 0;
        }
      }

      .dropdown-item {
        font-weight: bold;
        &:hover {
          color: $color-blue;
        }
      }
    }
  }
}
::v-deep .notification,
::v-deep .profile {
  display: none !important;
}

::v-deep .dashboard-button {
  position: absolute;
  bottom: 0;
  right: $spacer;
}
</style>
